import { render, staticRenderFns } from "./InfoCollapsible.vue?vue&type=template&id=4ec8a6da&scoped=true&"
import script from "./InfoCollapsible.vue?vue&type=script&lang=js&"
export * from "./InfoCollapsible.vue?vue&type=script&lang=js&"
import style0 from "./InfoCollapsible.vue?vue&type=style&index=0&id=4ec8a6da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8a6da",
  null
  
)

export default component.exports